import { CompanySmsSendingRuleAutoClaimBase } from "@/souhl_admin/gql/__generated__/graphql"

export const AUTO_CLAIM_BASE_LABEL: Record<
	CompanySmsSendingRuleAutoClaimBase,
	string
> = {
	CANCEL_DATE: "キャンセル日",
	RESERVATION_RECEIPTED_DATE: "予約受信日",
}

export const FIELD_LABEL: Record<
	"autoClaimBase" | "autoClaimStartDate" | "encourageStartCancelDate",
	string
> = {
	autoClaimBase: "自動請求開始基準",
	autoClaimStartDate: "請求開始日",
	encourageStartCancelDate: "再予約開始日",
}
